import styled from "styled-components";

export const PlayerWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;
